import { render, staticRenderFns } from "./newAfterList.vue?vue&type=template&id=4b1bdb3b&"
import script from "./newAfterList.vue?vue&type=script&lang=js&"
export * from "./newAfterList.vue?vue&type=script&lang=js&"
import style0 from "./newAfterList.vue?vue&type=style&index=0&id=4b1bdb3b&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b1bdb3b')) {
      api.createRecord('4b1bdb3b', component.options)
    } else {
      api.reload('4b1bdb3b', component.options)
    }
    module.hot.accept("./newAfterList.vue?vue&type=template&id=4b1bdb3b&", function () {
      api.rerender('4b1bdb3b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/newAfterList.vue"
export default component.exports